import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import AuthenticatedLayout from './AuthenticatedLayout';

/**
 * A layout that ensures the user is authenticated and redirects to the login page if not.
 */
export default function Authenticated(props: {
  children: React.ReactNode;
  navbarBrandAddon?: React.ReactNode;
}): React.ReactElement {
  const { children, navbarBrandAddon } = props;
  const user = useUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <AuthenticatedLayout user={user} navbarBrandAddon={navbarBrandAddon}>
      {children}
    </AuthenticatedLayout>
  );
}
